import { Card, CardHeader, CardContent } from '#app/components/ui/card.tsx'

const Terms = () => {
	return (
		<Card>
			<CardHeader>
				<h1 className="text-xl font-heading leading-none tracking-tight">
					Terms of Service
				</h1>
			</CardHeader>
			<CardContent>
				<div className="prose max-w-full">
					<p>
						<strong>Effective Date:</strong> 10th January 2025
					</p>

					<p>
						Welcome to ReactionVideos.xyz! By using our website, you agree to
						the following Terms of Service. Please read them carefully before
						using our platform.
					</p>

					<h2 className="text-lg">1. Acceptance of Terms</h2>
					<p>
						By accessing or using ReactionVideos.xyz, you agree to comply with
						and be bound by these Terms of Service and our Privacy Policy. If
						you do not agree, you may not use the site.
					</p>

					<h2 className="text-lg">2. Eligibility</h2>
					<p>
						You must be at least 13 years old to use ReactionVideos.xyz. By
						using the site, you represent that you meet this age requirement.
					</p>

					<h2 className="text-lg">3. User Accounts</h2>
					<ul>
						<li>
							You are responsible for maintaining the confidentiality of your
							account information.
						</li>
						<li>
							You agree to provide accurate information when creating an
							account.
						</li>
						<li>
							ReactionVideos.xyz reserves the right to terminate accounts that
							violate these terms or are used for unauthorized purposes.
						</li>
					</ul>

					<h2 className="text-lg">4. User-Generated Content</h2>
					<p>
						By submitting content (e.g., video links, votes) to
						ReactionVideos.xyz, you grant us a non-exclusive, worldwide,
						royalty-free license to use, display, and distribute your content on
						the platform.
					</p>
					<ul>
						<li>
							You are solely responsible for the content you submit and agree
							not to upload any material that violates copyright, privacy, or
							other applicable laws.
						</li>
						<li>
							ReactionVideos.xyz reserves the right to remove content that
							violates these Terms of Service or is deemed inappropriate.
						</li>
					</ul>

					<h2 className="text-lg">5. Prohibited Activities</h2>
					<p>You agree not to:</p>
					<ul>
						<li>Submit false or misleading content.</li>
						<li>
							Engage in unauthorized scraping, data mining, or other automated
							activities.
						</li>
						<li>Harass, abuse, or harm other users.</li>
						<li>
							Attempt to interfere with the website's functionality or security.
						</li>
					</ul>

					<h2 className="text-lg">6. Intellectual Property</h2>
					<p>
						All content and materials on ReactionVideos.xyz (excluding
						user-generated content) are the property of ReactionVideos.xyz and
						protected by copyright and other laws. You may not copy, modify, or
						distribute this content without permission.
					</p>

					<h2 className="text-lg">7. Disclaimer of Warranties</h2>
					<p>
						ReactionVideos.xyz is provided "as is" without any warranties,
						express or implied. We do not guarantee the accuracy, reliability,
						or availability of the platform.
					</p>

					<h2 className="text-lg">8. Limitation of Liability</h2>
					<p>
						To the extent permitted by law, ReactionVideos.xyz is not liable for
						any direct, indirect, incidental, or consequential damages arising
						from your use of the site.
					</p>

					<h2 className="text-lg">9. Changes to the Terms</h2>
					<p>
						We may update these Terms of Service from time to time. Changes will
						be posted on this page with an updated "Effective Date." Continued
						use of the site constitutes acceptance of the revised terms.
					</p>

					<h2 className="text-lg">10. Governing Law</h2>
					<p>
						These Terms of Service are governed by the laws of the United
						Kingdom. Any disputes will be resolved in the courts of the United
						Kingdom.
					</p>

					<h2 className="text-lg">Contact Us</h2>
					<p>
						If you have any questions about these Terms of Service, please
						contact us at hello@reactionvideos.xyz.
					</p>
				</div>
			</CardContent>
		</Card>
	)
}

export default Terms
